import type React from 'react';

import type { UserPermission } from '@cobliteam/common-types';

import { usePermissions } from '@cobliteam/hooks';

interface PermissionsGateProps {
  anyOfPermissions: UserPermission | UserPermission[];
  children?: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const PermissionsGate = ({ anyOfPermissions, children, fallback }: PermissionsGateProps) => {
  const { isAccessAllowed } = usePermissions();
  const permissionsArray: UserPermission[] = Array.isArray(anyOfPermissions) ? anyOfPermissions : [anyOfPermissions];
  if (permissionsArray.find(isAccessAllowed)) {
    return children;
  }
  if (fallback) {
    return <>{fallback}</>;
  }
  return null;
};

const withPermission = (anyOfPermissions: UserPermission, Component: React.ComponentType<any>, FallbackComponent?: React.ComponentType<any>) => {
  const ComponentParent = (props: any) => {
    const { isAccessAllowed } = usePermissions();
    if (isAccessAllowed(anyOfPermissions)) {
      return <Component {...props} />;
    }
    if (FallbackComponent) {
      return <FallbackComponent />;
    }
    return null;
  };

  return ComponentParent;
};

const withPermissionWithProps = (anyOfPermissions: UserPermission, Component: React.ComponentType<any>, FallbackComponent?: React.ComponentType<any>) => {
  const ComponentParent = (props: any) => {
    const { isAccessAllowed } = usePermissions();
    if (isAccessAllowed(anyOfPermissions)) {
      return <Component {...props} />;
    }
    if (FallbackComponent) {
      return <FallbackComponent {...props} />;
    }
    return null;
  };

  return ComponentParent;
};

export { PermissionsGate };
export { withPermissionWithProps };
export default withPermission;
